export function SeverityBadge({ severity, className = "" }) {
    const labels = { low: "Low", medium: "Medium", high: "High" };
    const cls = {
        low: "bl-badge bl-badge-low",
        medium: "bl-badge bl-badge-medium",
        high: "bl-badge bl-badge-high",
    };
    const sev = severity || "low";
    return (
        <span
            className={(cls[sev] || cls.low) + " " + className}
            data-testid={`severity-badge-${sev}`}
        >
            <span
                className="inline-block w-1.5 h-1.5 rounded-full"
                style={{
                    background:
                        sev === "high"
                            ? "var(--bl-rust)"
                            : sev === "medium"
                              ? "var(--bl-amber)"
                              : "var(--bl-moss)",
                }}
            />
            {labels[sev] || "Low"} Priority
        </span>
    );
}
